export enum AuthenticationType {
	None = 0,
	Bearer = 1,
	Basic = 2
}